import {NgModule} from '@angular/core';
import {ProfessionalLiabilityPageComponent} from './professional-liability-page.component';
import {PageCommonModule} from '../shared/page-common.module';
import {FormsModule} from '../../components/forms/forms.module';
import {StepScreenModule} from '../shared/step/step-screen.module';
import {MalpracticeScreenComponent} from './steps/malpractice/malpractice-screen.component';
import {LicensesAndAffiliationsScreenComponent} from './steps/licenses-and-affiliations/licenses-and-affiliations-screen.component';
import {DisciplinaryActionsScreenComponent} from './steps/disciplinary-actions/disciplinary-actions-screen.component';
import {HealthStatusScreenComponent} from './steps/health-status/health-status-screen.component';
import {FileListModule} from '../../components/files/file-list/file-list.module';
import {FileUploaderModule} from '../../components/files/file-uploader/file-uploader.module';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [
        PageCommonModule,
        FormsModule,
        StepScreenModule,
        FileListModule,
        FileUploaderModule
    ],
    declarations: [
        ProfessionalLiabilityPageComponent,
        MalpracticeScreenComponent,
        LicensesAndAffiliationsScreenComponent,
        DisciplinaryActionsScreenComponent,
        HealthStatusScreenComponent
    ]
})
export class ProfessionalLiabilityPageModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/liability/professional-liability-page.module.ts